import us from '../us.svg';
import dk from "../dk.svg"


import '../App.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import EnvironmentService from "../service/environmentService";
import { Link } from "react-router-dom";
import ShowService from '../service/showService';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}

class ShowEpisodeOverview extends Component {
    // var movies = [];


  constructor(props){
    super(props);

    this.environmentService = new EnvironmentService();
    this.ShowService = new ShowService();

    this.state = {
        episode : {},
        variants : []
    }
  }

    componentDidMount()
    {
        this.getEpisodeDetail();
        this.getEpisodeVariants();
    }

  async getEpisodeDetail(){
    var result = await this.ShowService.GetEpisodeDetail(this.props.params.uuid)

   this.setState({
    episode : result
   })
  }
async getEpisodeVariants(){
   var result = await this.ShowService.GetEpisodeVariants(this.props.params.uuid);

   this.setState({
    variants : result
   })
}


renderLanguageImage(imageKey){
    var imageVariant;
    switch(imageKey){
      case "DA":
          imageVariant = dk;
          break;
      default:
          imageVariant = us;
          break;
      }
      return imageVariant
    }


  render(){
    const episodedetailed = this.state.episode;
    if(!episodedetailed) return null;

    const variants = this.state.variants;
    if(!variants) return null;

    return(
        <div>
        <Link to={"/shows/season/" + episodedetailed.seasonUuid}>Back</Link>
        <div className="movieoverview"> 
        <p>{episodedetailed.name}</p>
        <div className="languages">
          {
            variants.map((episodeVariant) =>(

            <div className="inner" key={episodeVariant}>
              <div>
                <Link key={episodeVariant}  to={"/shows/episode/stream/" + this.props.params.uuid+ "?variant=" + episodeVariant }><img src={this.renderLanguageImage(episodeVariant)} width="60px" height="60px" alt="HTML tutorial"/></Link>
              </div>
            </div>
            ))
          }       
          </div> 
        </div>
      </div> 
      )
  }
}

export default withParams(ShowEpisodeOverview);
